<template>
    <div>
        <h1 class="text-sm pt-2">
            {{$t('form.direct.message_vendeur')}}
        </h1>
        <div class="shadow border border-gray-200 p-6 my-4 my-rounded bg-white">
            <span v-if="data" v-html="data"></span>
        </div>
    </div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'direct',
    extends: FormCardExtension,

    methods: {
        async init() {
            let setCase = JSON.parse(this.$formTool.getFormData('set-case'))
            this.data = await apiService.text('direct', this.$formTool.getFormData('proc').id, setCase.id_case)
            // this.data = JSON.parse(this.$formTool.getFormData('set-case'))
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            this.emitChange()
        }
    },

    mounted() {
        
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/DirectCard.vue